import StatCard from "./StatCard";

export default function StatsGrid({ cards, className = "" }) {
  return (
    <div className={`stats-grid ${className}`.trim()}>
      {cards.map((card) => (
        <StatCard
          key={card.key}
          icon={card.icon}
          label={card.label}
          value={card.value}
          subtext={card.sub}
          tone={card.tone}
          animate={card.animate}
          onClick={card.onClick}
          tooltip={card.tooltip}
        />
      ))}
    </div>
  );
}
